export const companiesCompanyIdSenderVerificationEligibility =
  "/companies/:company_id/sender_verification/eligibility";
